"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirestoreOptionalCollectionData = exports.useFirestoreOptionalDocData = void 0;
const firestore_1 = require("firebase/firestore");
const reactfire_1 = require("reactfire");
const firestore_2 = require("rxfire/firestore");
const rxjs_1 = require("rxjs");
// From reactfire. Extracted to be able to implement optional queries
// Since we're side-effect free, we need to ensure our observableId cache is global
const cachedQueries = 
// eslint-disable-next-line no-underscore-dangle
globalThis._reactFireFirestoreQueryCache || [];
// eslint-disable-next-line no-underscore-dangle
if (!globalThis._reactFireFirestoreQueryCache) {
    // eslint-disable-next-line no-underscore-dangle
    globalThis._reactFireFirestoreQueryCache = cachedQueries;
}
function getUniqueIdForFirestoreQuery(query) {
    if (!query)
        return 'undefined';
    const index = cachedQueries.findIndex((cachedQuery) => (0, firestore_1.queryEqual)(cachedQuery, query));
    if (index > -1) {
        return index;
    }
    return cachedQueries.push(query) - 1;
}
const observableOfUndefined = (0, rxjs_1.of)(undefined);
const observableOfEmptyArray = (0, rxjs_1.of)([]);
/**
 * Subscribe to Firestore Document changes and unwrap the document into a plain object
 */
function useFirestoreOptionalDocData(ref, options) {
    const idField = options ? (0, reactfire_1.checkIdField)(options) : 'NO_ID_FIELD';
    const observableId = ref
        ? `firestore:docData:${ref.firestore.app.name}:${ref.path}:idField=${idField}`
        : `firestore:docData:undefined`;
    const observable = ref ? (0, firestore_2.docData)(ref, { idField }) : observableOfUndefined;
    return (0, reactfire_1.useObservable)(observableId, observable, options);
}
exports.useFirestoreOptionalDocData = useFirestoreOptionalDocData;
/**
 * Subscribe to a Firestore collection and unwrap the snapshot into an array.
 * If undefined query return empty array.
 */
function useFirestoreOptionalCollectionData(query, options) {
    const idField = options ? (0, reactfire_1.checkIdField)(options) : 'NO_ID_FIELD';
    const observableId = `firestore:collectionData:${query ? getUniqueIdForFirestoreQuery(query) : 'undefined'}:idField=${idField}`;
    const observable$ = query ? (0, firestore_2.collectionData)(query, { idField }) : observableOfEmptyArray;
    return (0, reactfire_1.useObservable)(observableId, observable$, options);
}
exports.useFirestoreOptionalCollectionData = useFirestoreOptionalCollectionData;
//# sourceMappingURL=reactfire-optional-hooks.js.map